export interface GPUCapability {
  webgpu: boolean;
  webgl2: boolean;
  fallback: 'webgpu' | 'webgl2' | 'none';
}

export async function detectGPUCapability(): Promise<GPUCapability> {
  const webgpu = typeof navigator !== 'undefined' && 'gpu' in navigator;
  const webgl2 = (() => {
    try {
      const canvas = document.createElement('canvas');
      return !!canvas.getContext('webgl2');
    } catch {
      return false;
    }
  })();

  let gpuAvailable = false;
  if (webgpu) {
    try {
      const adapter = await navigator.gpu.requestAdapter();
      gpuAvailable = !!adapter;
    } catch {
      gpuAvailable = false;
    }
  }

  return {
    webgpu: gpuAvailable,
    webgl2,
    fallback: gpuAvailable ? 'webgpu' : webgl2 ? 'webgl2' : 'none',
  };
}
